module.exports = __webpack_public_path__ + "img/avatar-5.f21b3dd2.jpg";